import { render, staticRenderFns } from "./SideNavLink.vue?vue&type=template&id=d8862f6c&scoped=true&"
import script from "./SideNavLink.vue?vue&type=script&lang=js&"
export * from "./SideNavLink.vue?vue&type=script&lang=js&"
import style0 from "./SideNavLink.vue?vue&type=style&index=0&id=d8862f6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8862f6c",
  null
  
)

component.options.__file = "SideNavLink.vue"
export default component.exports